module.exports = __webpack_public_path__ + "img/competitors.4739b41f.png";